import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { Box, Flex, Text } from '@chakra-ui/react';

import { adminUserQueries } from '@/features/admin-users/api/adminUserQueries';
import { AdminUserTable } from '@/features/admin-users/components/AdminUserTable';
import { Button } from '@/components/ui/Button';

const usersSearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.number().int().min(1).max(100).catch(20),
});

export const Route = createFileRoute('/_authenticated/users/')({
  validateSearch: zodValidator(usersSearchSchema),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(adminUserQueries.list(deps.search)),
  component: UsersPage,
});

function UsersPage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold">
          管理者ユーザー
        </Text>
        <Button colorPalette="brand" onClick={() => navigate({ to: '/users/new' })}>
          新規作成
        </Button>
      </Flex>

      <AdminUserTable
        search={search}
        onSearchChange={(partial) => navigate({ search: (prev) => ({ ...prev, ...partial }) })}
      />
    </Box>
  );
}
